import api from "../../helpers/api";

export const getFavArtisanProducts = (customerId) => api.post(`customer/getfavorites-artisans/`,customerId)


export const addFavArtisanProduct = (customerId,productID) => api.post(`customer/addfavorite-artisan/`, customerId, productID)


export const remFavArtisanProduct = (customerId, productID) => api.post(`customer/remfavorite-artisan/`,customerId, productID)
